import { useAuthStore } from '@/stores/authentication.ts';
import { type RouteLocationNormalized, type NavigationGuardNext } from 'vue-router';

export default (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const authStore = useAuthStore();
  if (!authStore.access?.superAdmin && !authStore.access?.permissions?.monitoring?.view) {
    next('/');
  } else {
    next();
  }
}
